<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <div class="vx-row mb-base mb-5">
      <div class="vx-col w-full md:w-2/5">
        <div class="vx-row mb-5" v-if="borrowers.length >= 1">
          <vx-card>
            <div class="vx-col w-full vx-coll-fit-height">
              <div class="flex pb-5">
                <div class="flex-1">
                  ผู้กู้
                </div>
                <div class="flex-1">
                  <vs-button class="float-right mr-1" size="small" @click="print(contract.id)">{{ "ดูไฟล์แนบ" }}</vs-button>
                </div>
              </div>
              <vs-table :data="borrowers" >
                <template slot="thead">
                  <vs-th>ชื่อ-สกุล</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                    <vs-td>
                      {{ row ? row.fullName : '' }}
                    </vs-td>
                    <vs-td>
                      <div class="vx-col w-full">
                        <vs-button class="float-right mr-1" size="small" v-if="smartAppStatus === 'Inspectioned' && contractStatus === 'Draft'" @click="messengerBorrowerUpload(contract.id, contract.verifyToken)">{{ "ลิ้งค์อัพโหลด" }}</vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
        <div class="vx-row mb-5">
          <vx-card>
            <div class="vx-col w-full vx-coll-fit-height">
              <div class="flex pb-5">
                <div class="flex-1">
                  ผู้ค้ำประกันจำนวน {{ suretyDetails.length }} คน
                </div>
              </div>
              <vs-table :data="suretyDetails" >
                <template slot="thead">
                  <vs-th>ลำดับ</vs-th>
                  <vs-th>ชื่อ-สกุล</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                    <vs-td>
                      {{ index+1 }}
                    </vs-td>
                    <vs-td>
                      {{ row.surety.fullName }}
                    </vs-td>
                    <vs-td>
                      <div class="vx-col w-full">
                        <vs-button class="float-right mr-1" size="small" @click="selectedSurety(row.id)">{{ "ดูข้อมูล" }}</vs-button>
                        <vs-button class="float-right mr-1" size="small" v-if="smartAppStatus === 'Inspectioned' && contractStatus === 'Draft'" @click="messengerSuretyUpload(row.id, contract.verifyToken)">{{ "ลิ้งค์อัพโหลด" }}</vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="vx-col w-full md:w-3/5">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full vx-coll-fixed-height">
              <template v-if="contract">
                <vs-divider position="center">ข้อมูลสัญญา</vs-divider>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เลขที่สัญญา</h6>
                    <p>{{ contract.contractNo }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ชื่อสัญญา</h6>
                    <p >{{ contract.contractName}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันที่สัญญา</h6>
                    <p >{{ contract.contractDate | convYYYYMMDDToDDMMYYYY }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ยอดเงินกู้</h6>
                    <p >{{ contract.contractAmount | numberFormat }}</p>
                  </div>
                </div>
                <vs-divider position="center">ข้อมูลหลักสูตร</vs-divider>
                  <div class="vx-row" v-if="curriculumExternal">
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2">
                      <h6>คณะ</h6>
                      <p >{{ curriculumExternal.facultyName}}</p>
                    </div>
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2">
                      <h6>หลักสูตร</h6>
                      <p >{{ curriculumExternal.curriculumName}}</p>
                    </div>
                  </div>
                  <div class="vx-row" v-if="curriculumExternal">
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                      <h6>ระดับการศึกษา</h6>
                      <p >{{ curriculumExternal.degreeName}}</p>
                    </div>
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                      <h6>ปีการศึกษา</h6>
                      <p >{{ curriculumExternal.periodTerm}}/{{ curriculumExternal.periodYear}}</p>
                    </div>
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                      <h6>วันที่เริ่มเรียน</h6>
                      <p >{{ curriculumExternal.startDate | convYYYYMMDDToDDMMYYYY}}</p>
                    </div>
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                      <h6>วันที่จบการศึกษา</h6>
                      <p >{{ curriculumExternal.graduationDate | convYYYYMMDDToDDMMYYYY}}</p>
                    </div>
                  </div >
                  <div class="vx-row" v-if="curriculumExternal">
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2">
                      <h6>เริ่มชำระดอกเบี้ยวันที่</h6>
                      <p v-if="curriculumExternal.loanDetail.interestPeriodDetail.periods > 0" >{{ curriculumExternal.loanDetail.interestPeriodDetail.startDate}} - {{ curriculumExternal.loanDetail.interestPeriodDetail.endDate}} ({{ curriculumExternal.loanDetail.interestPeriodDetail.periods }} งวด)</p>
                      <p v-else >-</p>
                    </div>
                    <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2">
                      <h6>เริ่มชำระเงินต้นวันที่</h6>
                      <p >{{ curriculumExternal.loanDetail.principlePeriodDetail.startDate}} - {{ curriculumExternal.loanDetail.principlePeriodDetail.endDate}} ({{ curriculumExternal.loanDetail.principlePeriodDetail.periods }} งวด)</p>
                    </div>
                  </div>
              </template>
              <template v-if="borrower">
                <vs-divider position="center">ข้อมูลผู้กู้</vs-divider>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เลขที่บัตรประชาชน</h6>
                    <p>{{ borrower.idCardNumber }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ออกให้เมื่อวันที่</h6>
                    <p >{{ borrower.issueDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันที่หมดอายุ</h6>
                    <p >{{ borrower.expDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันเกิด</h6>
                    <p >{{ borrower.birthDay | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เพศ</h6>
                    <p >{{ borrower.genderName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ชื่อ-สกุล</h6>
                    <p >{{ borrower.fullName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เบอร์โทร</h6>
                    <p >{{ borrower.mobile }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>อีเมล</h6>
                    <p >{{ borrower.email }}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full">
                    <h6>ที่อยู่</h6>
                    <p >{{ borrower.fullAddress }}</p>
                  </div>
                </div>
              </template>
              <template v-if="suretyDetail && surety">
                <vs-divider position="center">ข้อมูลผู้ค้ำประกัน</vs-divider>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เลขที่บัตรประชาชน</h6>
                    <p>{{ surety.idCardNumber }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ออกให้เมื่อวันที่</h6>
                    <p >{{ surety.issueDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันที่หมดอายุ</h6>
                    <p >{{ surety.expDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันเกิด</h6>
                    <p >{{ surety.birthDay | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เพศ</h6>
                    <p >{{ surety.genderName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ชื่อ-สกุล</h6>
                    <p >{{ surety.fullName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เบอร์โทร</h6>
                    <p >{{ surety.mobile }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>อีเมล</h6>
                    <p >{{ surety.email }}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เป็นผู้ปกครองหรือไม่</h6>
                    <p >{{ surety.parents ? 'ใช่' : 'ไม่ใช่' }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ความเกี่ยวข้องกับผู้กู้</h6>
                    <p >{{ suretyDetail.relationship }}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full">
                    <h6>ที่อยู่</h6>
                    <p >{{ surety.fullAddress }}</p>
                  </div>
                </div>
                <div class="vx-row flex">
                  <div class="vx-col mb-5 w-full xl:w-1/4">
                    <h6>วันที่นัดหมาย <vs-button v-if="smartAppStatus === 'Inspectioned' && contractStatus === 'Draft'" style="float: right;" color="warning" type="flat" icon-pack="feather" icon="icon-edit" @click="editAppointment(suretyDetail.id)"></vs-button></h6>
                    <p>{{ suretyDetail.appointmentDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 flex-1">
                    <h6>รายละเอียดการนัดหมาย</h6>
                    <p>{{ suretyDetail.appointmentRemark }}</p>
                  </div>
                </div>
                <vs-divider position="center">ประวัติการนัดหมาย</vs-divider>
                <div v-for="row in appointmentLogs" v-bind:key="row.id" >
                  <div class="vx-row">
                    <div class="vx-col">
                      <h6 style="line-height: 20px">{{ `${`ครั้งที่ ${row.seq}`} ${row.date != '' ? 'วันที่นัด ' + row.date : ''}` }}</h6>
                      <p style="line-height: 20px">{{ `${ row.remark != '' ? row.remark : '-' }` }}</p>
                      <p style="line-height: 20px">{{ `โดย ${ row.createdBy.fullName } ${convFormatDateTime(row.createdAt)} ` }}</p>
                    </div>
                  </div>
                  <hr class="custom-hr">
                </div>
              </template>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-prompt
      @accept="acceptEditAppointment"
      color="warning"
      title="แก้ไขข้อมูลการนัดหมาย"
      :active.sync="modalAppointment.active">
      <div>
        วันที่นัดหมาย
        <flat-pickr :config="configDatePicker" v-model="modalAppointment.form.date" class="mb-2 w-full"/>
        <vs-textarea placeholder="รายละเอียดการนัดหมาย" v-model="modalAppointment.form.remark" class="mb-2 w-full" rows="5"/>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createNamespacedHelpers } from 'vuex'
import vSelect from 'vue-select'
const moment = require('moment');

import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th.js'
import 'flatpickr/dist/themes/dark.css';
import {updateSuretyDetail} from "@/store/modules/accounting/actions";

const {mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  components: {
    vSelect,
    flatPickr
  },
  data(){
    return {
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      modalAppointment: {
        id: "",
        active: false,
        form: {
          date: "",
          remark: "",
        }
      }
    }
  },
  async created () {
    const vm = this
    await vm.getNotificationContractSale({form: {id: vm.$route.params.id}});
    await vm.getSuretyDetail({form: {id: vm.suretyDetails[0].id}});
  },
  computed: {
    ...mapAccountingState([ 'status', 'contract', 'suretyDetails', 'suretyDetail']),
    borrower (){
      return this.contract.borrower
    },
    curriculumExternal (){
      return this.contract.curriculumExternal
    },
    borrowers (){
      if (this.contract){
        return [
          this.contract.borrower
        ]
      }else{
        return []
      }
    },
    surety (){
      return this.suretyDetail.surety
    },
    appointmentLogs (){
      return this.suretyDetail.appointmentLogs
    },
    smartAppStatus (){
      return this.contract.smartAppStatus
    },
    contractStatus (){
      return this.contract.contractStatus
    },
  },
  methods: {
    ...mapAccountingActions(['getNotificationContractSale', 'getSuretyDetail', 'updateSuretyDetail']),
    async print (id) {
      await this.$router.push({name: 'accounting-contract-print-sale', params: {id: id}})
    },
    async messengerBorrowerUpload (id, verifyToken) {
      const vm = this;
      let routeData = vm.$router.resolve({name: 'messenger-borrower-upload', params: { id: id, token: verifyToken }});
      window.open(routeData.href, '_blank');
    },
    async messengerSuretyUpload (id, verifyToken) {
      const vm = this;
      let routeData = vm.$router.resolve({name: 'messenger-surety-upload', params: { id: id, token: verifyToken }});
      window.open(routeData.href, '_blank');
    },
    async selectedSurety (id) {
      const vm = this;
      await vm.getSuretyDetail({form: {id: id}});
    },
    async editAppointment (id) {
      const vm = this;
      vm.modalAppointment.id = id;
      vm.modalAppointment.active = true;
      vm.modalAppointment.form.date = vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.suretyDetail.appointmentDate)
      vm.modalAppointment.form.remark = vm.suretyDetail.appointmentRemark;
    },
    async acceptEditAppointment(){
      const vm = this;
      await vm.updateSuretyDetail({
        id: vm.modalAppointment.id,
        form: {
          appointmentDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.modalAppointment.form.date),
          appointmentRemark: vm.modalAppointment.form.remark,
        },
        vm
      });
      await vm.getSuretyDetail({form: {id: vm.modalAppointment.id}});
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>


<style scoped>
.vx-coll-fit-height{
  display:block;
  width:100%;
  height:100%;
  overflow: auto;
}
.vx-coll-fixed-height{
  display:block;
  width:100%;
  min-height: 500px;
  height:100%;
  overflow: auto;
}
.custom-hr{
  margin-top: 10px; margin-bottom: 20px;border: 0;
  border-top: 1px solid #eee;
}
</style>
